module.exports = __webpack_public_path__ + "img/U.LULogo_bottom_new.274b52fd.png";